import React, { Component } from "react";

import data from "currency-codes/data";

import { Formik, Form } from "formik";
import {
	TextInput,
	SelectInput,
	CheckboxInput,
} from "../../../../forms/components";
import { EditMerchantSchema } from "../../../../forms/schema";

import { editDetails } from "../../../../libs/functions";
import Util from "../../../../libs/util";

import Swal from "sweetalert2";
import { has, isEmpty } from "lodash";

class ManageMerchantDetails extends Component {
	constructor(props) {
		super(props);

		const { merchant, resellers } = props;

		const priorityCode = ["SGD", "MYR", "USD"];
		const codes = [
			...data.filter((i) => priorityCode.includes(i.code)),
			...data.filter((i) => !priorityCode.includes(i.code)),
		];

		this.state = {
			initialValues: {
				name: merchant.name,
				receiptName: merchant.receiptName || "",
				statementName: merchant.statementName || "",
				reseller: merchant.reseller._id,
				mcc: merchant.mcc || 5812,
				requireSignature:
					typeof merchant.requireSignature === "boolean"
						? merchant.requireSignature
						: true,
				stripeTerminalLocation: merchant.stripeTerminalLocation || "",
				defaultCurrency: merchant.defaultCurrency || "702",
			},
			resellers,
			hasStripe:
				has(merchant, "midv2.stripe") && !isEmpty(merchant.midv2.stripe),
			currency: [
				...codes.map((d) => {
					return { name: d.code, value: d.number };
				}),
			],
		};
	}

	componentDidUpdate = (prevProps) => {
		if (
			JSON.stringify(prevProps.merchant) !== JSON.stringify(this.props.merchant)
		) {
			this.setState({
				initialValues: {
					name: this.props.merchant.name,
					receiptName: this.props.merchant.receiptName || "",
					statementName: this.props.merchant.statementName || "",
					reseller: this.props.merchant.reseller._id,
					mcc: this.props.merchant.mcc || 5812,
					stripeTerminalLocation:
						this.props.merchant.stripeTerminalLocation || "",
					requireSignature:
						typeof this.props.merchant.requireSignature === "boolean"
							? this.props.merchant.requireSignature
							: true,
					defaultCurrency: this.props.merchant.defaultCurrency || "702",
				},
				hasStripe:
					has(this.props, "merchant.midv2.stripe") &&
					!isEmpty(this.props.merchant.midv2.stripe),
			});
		}

		if (
			JSON.stringify(prevProps.resellers) !==
			JSON.stringify(this.props.resellers)
		) {
			this.setState({ resellers: this.props.resellers });
		}
	};

	openEdit = () => {
		Util.showModal("edit-details");
	};

	closeEditModal = () => {
		Util.hideModal("edit-details");
	};

	editDetails = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Editing Merchant",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				this.closeEditModal();
			},
			onOpen: async () => {
				try {
					let status = await editDetails({
						id: this.props.merchant.id,
						...values,
					});
					Swal.hideLoading();
					setSubmitting(false);

					if (status) {
						Swal.fire({
							icon: "success",
							title: "Details Edited",
						}).then(() => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to Edit Details",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Edit Details`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	render() {
		const { merchant, readOnly, gateway } = this.props;
		const { initialValues, resellers, hasStripe, currency } = this.state;
		let requireSignature =
			typeof merchant.requireSignature === "boolean"
				? merchant.requireSignature
				: true;

		return (
			<div className="info-settings uk-margin-medium-bottom">
				<h4 className="uk-margin-remove">
					<span className="uk-flex uk-flex-middle">
						<i
							className="uk-margin-small-right form-header-icon"
							uk-icon="icon: fa-solid-info-circle; ratio: 0.9"
						/>
						Details
						{!readOnly && (
							<button
								className="uk-margin-left uk-icon-button uk-button-primary"
								uk-icon="icon: fa-solid-pencil-alt; ratio: 0.5"
								type="button"
								onClick={this.openEdit}
							/>
						)}
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</h4>
				<div className="uk-padding-small">
					<dl className="uk-description-list">
						<div className="uk-flex uk-margin-top">
							<div className="uk-width-1-2">
								<dt className="uk-margin-small-bottom">Reseller</dt>
								<dd className="uk-flex uk-flex-middle">
									{merchant.reseller.name}
								</dd>
							</div>
							<div className="uk-width-1-2">
								<dt className="uk-margin-small-bottom">MCC</dt>
								<dd className="uk-flex uk-flex-middle">{merchant.mcc}</dd>
							</div>
						</div>
						<div className="uk-flex uk-margin-top">
							<div className="uk-width-1-2">
								<dt className="uk-margin-small-bottom">Receipt Name</dt>
								<dd className="uk-flex uk-flex-middle">
									{merchant.receiptName || "T05 TECHNOLOGIES PTE. LTD."}
								</dd>
							</div>
							<div className="uk-width-1-2">
								<dt className="uk-margin-small-bottom">Statement Name</dt>
								<dd className="uk-flex uk-flex-middle">
									{merchant.statementName || "2C2P - T05 PAYMENT TEC"}
								</dd>
							</div>
						</div>
						<div className="uk-flex uk-margin-top">
							<div className="uk-width-1-2">
								<dt className="uk-margin-small-bottom">Default Currency</dt>
								<dd className="uk-flex uk-flex-middle">
									{Util.currencyNumToCode(merchant.defaultCurrency || "702")}
								</dd>
							</div>
						</div>

						<div className="uk-flex uk-margin-top">
							<div className="uk-width-1-1">
								<label className="uk-form-label">
									<input
										className="uk-checkbox uk-margin-right"
										type="checkbox"
										checked={requireSignature}
										readOnly
									/>
									Require Customer Signature
								</label>
							</div>
						</div>
						{hasStripe && (
							<div>
								<hr className="uk-margin-medium-top uk-margin-small-bottom" />
								<span className="uk-flex uk-flex-middle uk-margin-top">
									<img
										className="uk-img"
										src={`data:image/*;base64,${gateway["stripe"].image}`}
										width="50"
									/>
								</span>
								<div className="uk-flex uk-margin-top">
									<div className="uk-width-1-1">
										<dt className="uk-margin-small-bottom">
											Terminal Location ID
										</dt>
										<dd className="uk-flex uk-flex-middle">
											{merchant.stripeTerminalLocation || "-"}
										</dd>
									</div>
								</div>
							</div>
						)}
					</dl>
				</div>
				<div id="edit-details" uk-modal="stack: true">
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">Edit Merchant Details</h2>
						<Formik
							initialValues={initialValues}
							validationSchema={EditMerchantSchema.validation}
							enableReinitialize={true}
							onSubmit={this.editDetails}
						>
							<Form className="uk-form-stacked">
								<TextInput
									label="Merchant Name"
									id="name"
									name="name"
									type="text"
									placeholder=""
								/>
								{resellers && (
									<SelectInput
										label="Reseller"
										id="reseller"
										name="reseller"
										data={resellers.map((item) => {
											return { value: item._id, name: item.name };
										})}
									/>
								)}
								<TextInput
									label="Receipt Name"
									id="receiptName"
									name="receiptName"
									type="text"
									placeholder=""
								/>
								<TextInput
									label="Statement Name"
									id="statementName"
									name="statementName"
									maxLength="20"
									type="text"
									placeholder=""
								/>
								<TextInput
									label="Merchant Category Code"
									id="mcc"
									name="mcc"
									type="number"
									placeholder=""
								/>
								<SelectInput
									label="Default Currency"
									data={currency}
									id="defaultCurrency"
									name="defaultCurrency"
								/>
								<CheckboxInput
									name="requireSignature"
									id="requireSignature"
									label="Require Customer Signature"
								/>

								{hasStripe && (
									<div>
										<span className="uk-flex uk-flex-middle uk-margin-medium-top">
											<img
												className="uk-img"
												src={`data:image/*;base64,${gateway["stripe"].image}`}
												width="50"
											/>
										</span>
										<TextInput
											label="Terminal Location ID"
											id="stripeTerminalLocation"
											name="stripeTerminalLocation"
											type="text"
											placeholder=""
										/>
									</div>
								)}

								<p className="uk-text-right">
									<button
										className="uk-button uk-button-default uk-modal-close"
										type="button"
									>
										Cancel
									</button>
									<button className="uk-button uk-button-primary" type="submit">
										Edit
									</button>
								</p>
							</Form>
						</Formik>
					</div>
				</div>
			</div>
		);
	}
}

export default ManageMerchantDetails;
